var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var lib_geometry = require("lib-geometry");
if(typeof window !== 'undefined') var ui_extensions = require("ui-extensions");
var editor_3d = require("editor-3d-light");
var THREE           = require("three");
var AbstractMoveable3dObjectModel = require("editor-3d-light").AbstractMoveable3dObjectModel;
var cio_config = require("cio-config");
var ThreejsDefaults = cio_datamodel.ThreejsDefaults;


var FootprintInstanceInteractionModel = function (footprintData, packageIM, config) {
    editor_3d.AbstractSelectable3dObjectModel.call(this, packageIM.editorModel, config.handles);
    editor_3d.AbstractMoveable3dObjectModel.call(this);

    var self = this;
    //this.scale = packageIM.editorModel.config.scale;
    this.config = config;
    this.loadingModel = packageIM.processModel;
    this.selectionModel = packageIM.selectionModel;
    this.footprintOpen = config.footprintOpen;
    this.versionEdit = config.versionEdit;
    this.placementEdit = config.placementEdit;
    this.worldScale = packageIM.editorModel.worldScale;

    this.packageIM = packageIM;

    this.sizeX = packageIM.sizeX;
    this.sizeY = packageIM.sizeY;
    this.sizeZ = packageIM.sizeZ;

    this.modelOrigin = packageIM.modelCenterOrigin;
    this.footprintOrigin = packageIM.footprintCenterOrigin;
    this.converter = cio_config.UnitConversions;
    this.defaultDisplayUnit = this.converter.defaultDisplayUnit;
    this.distanceDataUnit = this.converter.distanceDataUnit;
    this.rotationDataUnit = this.converter.rotationDataUnit;
    this.distanceUnit = this.packageIM.userSettingsModel.distanceUnit;
    this.rotationUnit = this.packageIM.userSettingsModel.rotationUnit;
    this.editorUnit = this.packageIM.editorUnit;

    //bools to make "View IPC param" button active/inactive/disabled in inspector
    this.readOnlyIPCParamsVisible = this.value("readOnlyIPCParamsVisible", true);
    this.disableViewIPCParamButton = this.value("disableViewIPCParamButton", true);

    this.data = footprintData;

    //this.centroidOrigin = this.value("centroidOrigin", true);
    this.snapped = this.value("snapped", true);
    this.snapped(false);
    //this.packageOrigin = this.value("packageOrigin", true);

    this.packageMatrix = this.value("packageMatrix", true);
    this.footprintRenderGroup = this.value("footprintRenderGroup", true);
    this.boardRenderGroup = this.value("boardRenderGroup", true);

     //////////// changing the versions of footrints /////////////////
    this.version = function() {
        return self.data.ancestor().root.header["version"];
    };

    this.versions = this.value("versions", true);
    this.versions([]);

    this.hasInitialImportSavePoint = this.value("hasInitialImportSavePoint", true);

    /*this.versionsLoaded = this.value("versionsLoaded", true);
    this.versionsLoaded(false);

    this.versionsNotLoaded = this.shadow("versionsNotLoaded",    // TODO see if we can get rid of this to save (a little) memory
        function() {
            return !self.versionsLoaded();
        }, null,
        [this.versionsLoaded]
    );*/

    var asset = this.data.ancestor().root.getAssetFromHeader();

    if(asset) {
        //this.versions(this.getVersionsOptions(asset));
        //this.versionsLoaded(true);

        this.checkForInitialImportSavePoint(asset);
    }

   // this.inspectorSubjects.add(this.getVersionIM());

    // Setting the dafaults ////////////////////

    this.initPropertyShadows();

    this.data.description.onChange("rebuild3dGeometry", function(val){
        self.loadFootprintGeometry();
    });

    this.packageIM.showCustomSolderPaste.onChange(this, function(val) {
        self.footprintRenderGroup(self.footprintGroup());
    });

    if(this.packageIM.masterModel.wizardMode()){
        self.selectable(false);
    } else {
        if(this.packageIM.data.model3d()) {
            self.selectable(true);
        } else {
            self.selectable(false);
        }
    }

    this.packageIM.masterModel.wizardMode.onChange("makePackageSelectable", function(val){
        if(val){
            self.selectable(false);
        } else {
            self.selectable(true);
        }
    });

    // when the model changes, don't let select if from wip
    this.packageIM.data.model3d.onChange(this, function(val) {
        if(val instanceof cio_datamodel.Model3DReference){
          self.selectable(false);
          val.getResource().then((res)=>{
            if(res.forked_from && res.forked_from.wip_urn){
              self.selectable(false);
            } else {
              self.selectable(true);
            }
          })
        } else {
          if(val){
              self.selectable(true);
          } else {
              self.selectable(false);
          }
        }
    });
    
    // if model is from wip, disable selection
    if(this.packageIM.data.model3d() instanceof cio_datamodel.Model3DReference){
      self.selectable(false);
      this.packageIM.data.model3d().getResource().then((res)=>{
        if(res.forked_from && res.forked_from.wip_urn){
          self.selectable(false);
        } else {
          self.selectable(true);
        }
      })
    }
    
    self.loadFootprintGeometry();
};

lib_core.inherit(FootprintInstanceInteractionModel, editor_3d.AbstractSelectable3dObjectModel);
FootprintInstanceInteractionModel.$class = "FootprintInstanceInteractionModel";
module.exports = FootprintInstanceInteractionModel;

FootprintInstanceInteractionModel.prototype.loadFootprintGeometry = function()
{
    this.loadingModel.addLoad("FootprintGeometry", "Building Footprint Geometry");
    var footprint = this.footprintGroup();
    this.footprintRenderGroup(footprint);
    var board = this.boardGroup();
    this.boardRenderGroup(board);
    this.loadingModel.removeLoad("FootprintGeometry");
}


FootprintInstanceInteractionModel.prototype.exportFootprint = function()
{
    var scale = cio_config.UnitConversions.convert(cio_config.UnitConversions.distanceDataUnit, cio_config.UnitConversions.defaultDisplayUnit, 1);

    var group = this.footprintGroup().clone();
    var matrix = new THREE.Matrix4();
    matrix.makeScale(scale, scale, scale);
    group.matrix = matrix;

    group.scale.set(scale, scale, scale);
    group.updateMatrix();
    group.updateMatrixWorld();
    var exporter = new lib_geometry.ObjFileExport();
    var obj = exporter.parse(group);

    ui_extensions.BrowserUtil.downloadData(obj, this.data.description().metaData().name() + ".obj");
}


FootprintInstanceInteractionModel.prototype.createMovementPlane = function(ray, point){
    this.movementPlane.setComponents(0, 0, -1, point.z);
}

FootprintInstanceInteractionModel.prototype.getBestOrigin = function(){
    //console.log(this.data);
    if(this.data.boundingBox().intersects(new lib_geometry.Coord(0,0))) return false;
    return true;
}

//////////// I have to put these back because javascript doesn't do multiple inheritance  :(
FootprintInstanceInteractionModel.prototype.setContactPosition = function(){}
FootprintInstanceInteractionModel.prototype.setMousePosition = function(){};
FootprintInstanceInteractionModel.prototype.released = function(position){}

// contact position with the origin subtracted from the contact point
// (ok to set object to this WORLD position)
FootprintInstanceInteractionModel.prototype.setOffsetPosition = function(position, lessSnap){

    // snapping is done in here so it only applies to plane movement, axis handles allow for finer control
    //  w/o snapping
    if(lessSnap){
        var snapNum = 50;
    } else {
        var snapNum = 500;
    }

    var scale = this.converter.convert(this.defaultDisplayUnit, this.distanceDataUnit, 1);
    // go from mm in editor to um in data.
    // scale will always be 1000 (1mm to one um)

    var scaledPos = position.mult(scale);

    if(this.footprintOrigin()){
        var center2d = this.bestCenter();
        var center3d = new lib_geometry.Coord3d(center2d.x , center2d.y ,0);
    } else {
        var center3d = new lib_geometry.Coord3d(0,0,0);
    }
    var relPos = scaledPos.add(center3d.mult(-1));
    // if using footprint origin, that is now accounted for (relative position)

    if(Math.abs(relPos.x ) < snapNum && Math.abs(relPos.y ) < snapNum ){
        this.centerModel();
        this.snapped(true);

    } else {
        this.setWorldPosition(
            scaledPos ,
            this.getDegreesRotation(),
            this.modelOrigin()
        );

        this.snapped(false);
    }
}


// used by plane movement
FootprintInstanceInteractionModel.prototype.setPositionAndRotation = function(pos, rot){
    var scale = this.converter.convert(this.defaultDisplayUnit, this.distanceDataUnit, 1);
    var scaledPos = pos.mult(scale);

    this.setWorldPosition(
        pos,
        rot,
        this.modelOrigin()
    );
}

// used by handles
FootprintInstanceInteractionModel.prototype.getPosition = function(){
    var scale = this.converter.convert(this.distanceDataUnit, this.defaultDisplayUnit, 1);
    return this.getWorldPosition(this.modelOrigin()).mult(scale);
}

// used by handles
FootprintInstanceInteractionModel.prototype.getRotation = function(){
    return this.data.model3dRotation();
}

FootprintInstanceInteractionModel.prototype.checkForInitialImportSavePoint = function(asset) {
    var self = this;
    asset.getSavePoints().forEach(function(save_point, idx) {
        //if first savepoint is from import then this package is not generated from IPC data
        if(idx == 0 && save_point.type === "import") self.hasInitialImportSavePoint(true);
    });
};

FootprintInstanceInteractionModel.prototype.getVersionsOptions = function(asset) {
    var self = this;
    var versions = asset.getVersions().map(function(save_point, idx) {
        return [save_point.name, save_point.version];
    });
    return versions;
};

// Call these function with the data in MM (if coming from inspector convert first,
    // handles call these directly to move and threeJS world is always in MM)
FootprintInstanceInteractionModel.prototype.setX = function(threeUnit){
    var pos = this.getRelativePosition();
    this.setRelativePosition(
        this.converter.convert(this.defaultDisplayUnit, this.distanceDataUnit, threeUnit),
        pos.y,
        pos.z
    );
}

FootprintInstanceInteractionModel.prototype.setY = function(threeUnit){
    var pos = this.getRelativePosition();
    this.setRelativePosition(
        pos.x,
        this.converter.convert(this.defaultDisplayUnit, this.distanceDataUnit, threeUnit),
        pos.z
    );
}

FootprintInstanceInteractionModel.prototype.setZ = function(threeUnit){
    var pos = this.getRelativePosition();
    this.setRelativePosition(
        pos.x,
        pos.y,
        this.converter.convert(this.defaultDisplayUnit, this.distanceDataUnit, threeUnit)
    );
}

// must call this with rotation in degrees to set rotation
FootprintInstanceInteractionModel.prototype.setRotation = function(coord3dRotationInDegrees) {
     // must change rotation through this function because rotating may change actual position (although apparent position will not change)
    this.setWorldPosition(
        this.getWorldPosition(),
        coord3dRotationInDegrees,
        this.modelOrigin()
    );
};

// stuff used by inspector
FootprintInstanceInteractionModel.prototype.initPropertyShadows = function(position, rotation){

    this.inspectorX = this.shadow("X",
        function(){
            return this.converter.convert(this.distanceDataUnit, this.distanceUnit(), this.getRelativePosition().x );
        },
        function(val){
            this.setX(this.converter.convert(this.distanceUnit(), this.defaultDisplayUnit, val));
            return true;
        },
        [this.data.model3dPosition, this.data.model3dRotation,  this.footprintOrigin , this.modelOrigin, this.distanceUnit]
    );

    this.inspectorY = this.shadow("Y",
        function(){
            return this.converter.convert(this.distanceDataUnit, this.distanceUnit(), this.getRelativePosition().y );
        },
        function(val){
            this.setY(this.converter.convert(this.distanceUnit(), this.defaultDisplayUnit, val));
            return true;
        },
        [this.data.model3dPosition, this.data.model3dRotation,  this.footprintOrigin , this.modelOrigin, this.distanceUnit]
    );

    this.inspectorZ = this.shadow("Z",
        function(){
            return this.converter.convert(this.distanceDataUnit, this.distanceUnit(), this.getRelativePosition().z );
        },
        function(val){
            this.setZ(this.converter.convert(this.distanceUnit(), this.defaultDisplayUnit, val));
            return true;
        },
        [this.data.model3dPosition, this.data.model3dRotation,  this.footprintOrigin , this.modelOrigin, this.distanceUnit]
    );


    this.inspectorRotationX = this.shadow("rotationX",
        function(){
            return this.converter.convert(this.rotationDataUnit, this.rotationUnit(), this.data.model3dRotation().x);
        },
        function(val){
             // convert into degrees
            var rotation = new lib_geometry.Coord3d(
                 this.cap360(this.converter.convert(this.rotationUnit(), this.rotationDataUnit, val)),
                             this.converter.convert(this.rotationUnit(), this.rotationDataUnit, this.inspectorRotationY()),
                             this.converter.convert(this.rotationUnit(), this.rotationDataUnit, this.inspectorRotationZ())
            );
            // must change rotation through this function because rotating may change actual position (although apparent position will not change)
            this.setRotation(rotation);
            return true;
        },
        [this.data.model3dRotation, this.rotationUnit]
    );

    this.inspectorRotationY = this.shadow("rotationY",
        function(){
            return this.converter.convert(this.rotationDataUnit, this.rotationUnit(), this.data.model3dRotation().y);
        },
        function(val){
            // convert into degrees
            var rotation = new lib_geometry.Coord3d(
                            this.converter.convert(this.rotationUnit(), this.rotationDataUnit, this.inspectorRotationX()),
                this.cap360(this.converter.convert(this.rotationUnit(), this.rotationDataUnit, val)),
                            this.converter.convert(this.rotationUnit(), this.rotationDataUnit, this.inspectorRotationZ())
            );
            // must change rotation through this function because rotating may change actual position (although apparent position will not change)
            this.setRotation(rotation);
            return true;
        },
        [this.data.model3dRotation, this.rotationUnit]
    );

    this.inspectorRotationZ = this.shadow("rotationZ",
        function(){
            return this.converter.convert(this.rotationDataUnit, this.rotationUnit(), this.data.model3dRotation().z);
        },
        function(val){
            // convert into degrees
            var rotation = new lib_geometry.Coord3d(
                            this.converter.convert(this.rotationUnit(), this.rotationDataUnit, this.inspectorRotationX()),
                            this.converter.convert(this.rotationUnit(), this.rotationDataUnit, this.inspectorRotationY()),
                this.cap360(this.converter.convert(this.rotationUnit(), this.rotationDataUnit, val))
            );
            // must change rotation through this function because rotating may change actual position (although apparent position will not change)
            this.setRotation(rotation);
            return true;
        },
        [this.data.model3dRotation, this.rotationUnit]
    );



///////////////////////////////////////////////////

    this.tallness = this.shadow("tallness",
        function(){
            return this._getTallness();
        }, null,
        [this.packageIM.packageGeometry, this.data.model3dRotation]
    );


    this.padHolesPoly = this.cachedFunction("padHolesPoly",
        function(info){
            return this._getPadHoles(info);
        },
        [this.data.description]
    );

    this.boardHolesPoly = this.cachedFunction("boardHolesPoly",
        function(info){
            return this._getBoardHoles(info);
        },
        [this.data.description]
    );

    this.exposedCopperMesh = this.cachedFunction("exposedCopperMesh",
        function(info){
            var copperHeight = (info && info.copperHeight)? info.copperHeight : 1;
            var material = (info && info.copperMaterial)? info.copperMaterial : new THREE.MeshBasicMaterial({color: 0xff0000});
            var geom = this._buildCollectionGeometry(
                    [this.data.description().pads.filter(function(pad) {return pad.padstack().maskEnable();})],
                    false,
                    -copperHeight,
                    info,
                    this.padHolesPoly(info)
            ).getGeometry();

            if(!geom) return null;
            var mesh = new THREE.Mesh(geom, material);
            return mesh;
        },
        [this.data.description, this.padHolesPoly]
    );

    this.unexposedCopperMesh = this.cachedFunction("unexposedCopperMesh",
        function(info){
            var copperHeight = (info && info.copperHeight)? info.copperHeight : 1;
            var material = (info && info.unexposedCopperMaterial)? info.unexposedCopperMaterial : new THREE.MeshBasicMaterial({color: 0xff0000});
            var geom = this._buildCollectionGeometry(
                    [this.data.description().pads.filter(function(pad) {return !pad.padstack().maskEnable();})],
                    false,
                    -copperHeight,
                    info,
                    this.padHolesPoly(info)
            ).getGeometry();

            if(!geom) return null;
            var mesh = new THREE.Mesh(geom, material);
            return mesh;
        },
        [this.data.description, this.padHolesPoly]
    );

    this.solderPasteMesh = this.cachedFunction("solderPasteMesh",
        function(info){
            var solderPasteHeight = (info && info.solderPasteHeight)? info.solderPasteHeight : 1;
            var material = (info && info.solderPasteMaterial)? info.solderPasteMaterial : new THREE.MeshBasicMaterial({color: 0x00ff00});
            var geom = this._buildCollectionGeometry(
                    [this.data.description().solderPaste],
                    true,
                    -solderPasteHeight,
                    info,
                    []
            ).getGeometry();

            if(!geom) return null;
            var mesh = new THREE.Mesh(geom, material);
            return mesh;
        },
        [this.data.description]
    );

    this.silkscreenMesh = this.cachedFunction("silkscreenMesh",
        function(info){
            var copperHeight = (info && info.copperHeight)? info.copperHeight : 1;
            var silkscreenHeight = (info && info.silkscreenHeight)? info.silkscreenHeight : 1;
            var material = (info && info.silkscreenMaterial)? info.silkscreenMaterial : new THREE.MeshBasicMaterial({color: 0xffffff});
            var geom = this._buildCollectionGeometry(
                    [this.data.description().silkscreen, this.data.description().propNames, this.data.description().propValues],
                    true,
                    -copperHeight + (silkscreenHeight - copperHeight + 2),
                    info,
                    this.padHolesPoly(info)
            ).getGeometry();

            if(!geom) return null;
            var mesh = new THREE.Mesh(geom, material);
            return mesh;
        },
        [this.data.description, this.padHolesPoly]
    );

    this.documentationMesh = this.cachedFunction("documentationMesh",
        function(info){
            var documentationHeight = (info && info.documentationHeight)? info.documentationHeight : 1;
            var material = (info && info.documentationMaterial)? info.documentationMaterial : new THREE.MeshBasicMaterial({color: 0xffffff});
            var geom = this._buildCollectionGeometry(
                    [this.data.description().documentation],
                    true,
                    -documentationHeight,
                    info,
                    []
            ).getGeometry();
            if(!geom) return null;
            var mesh = new THREE.Mesh(geom, material);
            return mesh;
        },
        [this.data.description, this.padHolesPoly]
    );

    this.assemblyMesh = this.cachedFunction("assemblyMesh",
        function(info){
            var assemblyHeight = (info && info.assemblyHeight)? info.assemblyHeight : 1;
            var material = (info && info.assemblyMaterial)? info.assemblyMaterial : new THREE.MeshBasicMaterial({color: 0xffffff});
            var geom = this._buildCollectionGeometry(
                    [this.data.description().assembly],
                    false,
                    -assemblyHeight,
                    info,
                    []
            ).getGeometry();
            if(!geom) return null;
            var mesh = new THREE.Mesh(geom, material);
            return mesh;
        },
        [this.data.description, this.padHolesPoly]
    );


    this.boardGroup = this.cachedFunction("boardGroup",
        function(config){
            var group = new THREE.Group();
            var info = ThreejsDefaults;

            var material = (info && info.boardMaterial)? info.boardMaterial : new THREE.MeshBasicMaterial({color: 0x0000ff});
            var geom = this._buildBoardGeometry(info, this.boardHolesPoly(info)).getGeometry();
            if(geom){
                var mesh = new THREE.Mesh(geom, material);
                group.add(mesh);
            }
            return group;
        },
        [this.data.description, this.boardHolesPoly]
    );

    this.footprintGroup = this.shadow("footprintGroup",
        function(config){
            var group = new THREE.Group();
            var info = ThreejsDefaults;
            // TODO this is where I override with manufacture specs.
            var exposedCopper = this.exposedCopperMesh(info);
            var unexposedCopper = this.unexposedCopperMesh(info);
            var silk = this.silkscreenMesh(info);
            var docu = this.documentationMesh(info);
            var assembly = this.assemblyMesh(info);

            if(exposedCopper) group.add(exposedCopper);
            if(unexposedCopper) group.add(unexposedCopper);
            if(silk) group.add(silk);
            if(docu) group.add(docu);
            if(assembly) group.add(assembly);

            if(this.packageIM.showCustomSolderPaste()) {
                var solderPaste = this.solderPasteMesh(info);
                if(solderPaste) group.add(solderPaste);
            }

            return group;
        }, null,
        [this.exposedCopperMesh, this.unexposedCopperMesh, this.silkscreenMesh, this.packageIM.showCustomSolderPaste]
    );
}

FootprintInstanceInteractionModel.prototype.bestCenter = function() {
    return this.data.bestCenter();
};

FootprintInstanceInteractionModel.prototype.boundingBox = function() {
    return this.data.boundingBox();
};

FootprintInstanceInteractionModel.prototype.padsBoundingBox = function() {
    return this.data.padsBoundingBox();
};


FootprintInstanceInteractionModel.prototype.getBoardBuffer = function(){
    var info = ThreejsDefaults;
    var buffer = (info && info.boardBuffer)? info.boardBuffer : 1;
    return buffer;
}


// ( Coord(0,0,0), Coord(0,0,0), true, true ) will align the centroids.
// data should be coming in as correct data form (um and degrees)
FootprintInstanceInteractionModel.prototype.setWorldPosition = function(position, rotation, centerOriginP) {
    var dataPos = this._getRealPosition(position, rotation, centerOriginP);
    // now datapos is real
    this.data.model3dPosition(dataPos);
    this.data.model3dRotation(rotation);
}

// get the position (always in data units ((um and degrees)))
FootprintInstanceInteractionModel.prototype.getWorldPosition = function(){
    return this._getWorldPosition(this.data.model3dPosition(), this.data.model3dRotation(), this.modelOrigin());
}

// params will always be in data units (um and degrees)
FootprintInstanceInteractionModel.prototype._getWorldPosition = function(posData, rotData, centerOriginP){
    var rotation = new THREE.Euler(
        this.converter.convert(this.rotationDataUnit, "rad", rotData.x),
        this.converter.convert(this.rotationDataUnit, "rad", rotData.y),
        this.converter.convert(this.rotationDataUnit, "rad", rotData.z)
    );
    var data = (new THREE.Matrix4()).makeRotationFromEuler( rotation );
    data.setPosition( new THREE.Vector3(posData.x, posData.y, posData.z) );
    var THREECentroid = new lib_geometry.Coord3d(0,0,0).toThreejs();
    if(centerOriginP && this.packageIM.centroid())
        THREECentroid = this.packageIM.centroid().toThreejs().clone();
    var To = (new THREE.Matrix4()).setPosition( THREECentroid );
    var mult = (new THREE.Matrix4()).makeRotationFromEuler( rotation );
    mult.multiply(To);
    var inv = mult.clone().invert()
    data.multiply(inv);
    var position = (new THREE.Vector3()).setFromMatrixPosition(data);

    return new lib_geometry.Coord3d(position.x, position.y, position.z);
}

// params will allways be in data units (um and degrees)
FootprintInstanceInteractionModel.prototype._getRealPosition = function(worldPosition, worldRotation, centerOriginP){
    var rotation = new THREE.Euler(
        this.converter.convert(this.rotationDataUnit, "rad", worldRotation.x),
        this.converter.convert(this.rotationDataUnit, "rad", worldRotation.y),
        this.converter.convert(this.rotationDataUnit, "rad", worldRotation.z)
    );
    var R = (new THREE.Matrix4()).makeRotationFromEuler( rotation );
    var THREECentroid = new lib_geometry.Coord3d(0,0,0).toThreejs();
    if(centerOriginP && this.packageIM.centroid())
        THREECentroid = this.packageIM.centroid().toThreejs().clone();
    var To = (new THREE.Matrix4()).setPosition( THREECentroid);
    var Tw = (new THREE.Matrix4()).setPosition( worldPosition.toThreejs().clone() );
    var Rinv = R.clone().invert()
    var S = Tw.clone();
    S.multiply(R);
    S.multiply(To);

    var position = (new THREE.Vector3()).setFromMatrixPosition(S);

     return new lib_geometry.Coord3d(position.x, position.y, position.z);
}


/////////////////////////  convienient functions for helper buttons
FootprintInstanceInteractionModel.prototype.resetZtoBoard = function(){

    var pos = this.getWorldPosition();
    pos.z = (this.tallness() )/ 2;

    this.setWorldPosition(
        pos,
        this.getDegreesRotation(),
        true
    );
}

FootprintInstanceInteractionModel.prototype.centerModel = function(){
    // go from inspector to data
    var zPos = cio_config.UnitConversions.convert(this.distanceUnit(), cio_config.UnitConversions.distanceDataUnit, this.inspectorZ());
    this.setRelativePosition(0,0, zPos);
}

FootprintInstanceInteractionModel.prototype.setRelativePosition = function(x, y, z){
    var pos = new lib_geometry.Coord3d(x , y, z);
    if(this.footprintOrigin()){
        pos = pos.add(new lib_geometry.Coord3d(this.bestCenter().x, this.bestCenter().y, 0));
    }
     this.setWorldPosition(
        pos,
        this.getDegreesRotation(),
        this.modelOrigin()
    );
}

FootprintInstanceInteractionModel.prototype.getRelativePosition = function(){
    if(this.footprintOrigin()){
        var center2d = this.bestCenter();
        var center3d = new lib_geometry.Coord3d(center2d.x , center2d.y ,0);
    } else {
        var center3d = new lib_geometry.Coord3d(0,0,0);
    }
    var pos = this.getWorldPosition();
    return pos.add(center3d.mult(-1));
}

// a coord with the three inspector position values
FootprintInstanceInteractionModel.prototype.getInspectorPosition = function(){
    return new lib_geometry.Coord3d(this.inspectorX(), this.inspectorY(), this.inspectorZ());
}

// a coord with the three inspector rotation values
FootprintInstanceInteractionModel.prototype.getInspectorRotation = function(){
    return new lib_geometry.Coord3d(this.inspectorRotationX(), this.inspectorRotationY(), this.inspectorRotationZ());
}

FootprintInstanceInteractionModel.prototype.getDegreesRotation = function(){
    return new lib_geometry.Coord3d(
        this.converter.convert(this.rotationUnit(), this.rotationDataUnit, this.inspectorRotationX()),
        this.converter.convert(this.rotationUnit(), this.rotationDataUnit, this.inspectorRotationY()),
        this.converter.convert(this.rotationUnit(), this.rotationDataUnit, this.inspectorRotationZ())
    );
}


FootprintInstanceInteractionModel.prototype.cap360 = function(val){
    while(val < 0)
        val += 360;
    if(val > 360)
        val = val % 360;
    return val;
}

FootprintInstanceInteractionModel.prototype._getTallness = function(){
    // here 1234567

    var packageMesh = this.packageIM.packageGeometry().toThreejsMesh();
    var packageGroup = new THREE.Object3D();
    packageGroup.add(packageMesh);

    packageGroup.rotateX(this.data.model3dRotation().x * Math.PI/180);
    packageGroup.rotateY(this.data.model3dRotation().y * Math.PI/180);
    packageGroup.rotateZ(this.data.model3dRotation().z * Math.PI/180);

    var box = new THREE.Box3();
    box.setFromObject( packageGroup );
    return (box.max.z - box.min.z);
}

FootprintInstanceInteractionModel.prototype._getPadHoles = function(info){
    var holePrecision = (info && info.holePrecision)? info.holePrecision : 3;

    var polyons = [];
    this.data.description().holes.forEach(function(id, hole){
        var geom = hole.outlineGeometry(holePrecision);
        polyons.push(new lib_geometry.Polygon(geom.points));
    });
    this.data.description().pads.forEach(function(id, pad){
        if(pad.getDrillSegmentedGeometry){
            var geom = pad.getDrillSegmentedGeometry(holePrecision);
            if (geom != null) polyons.push(new lib_geometry.Polygon(geom.points));
        }
    });

    return lib_geometry.Union(polyons, []);
}

FootprintInstanceInteractionModel.prototype._getBoardHoles = function(info){
    var holePrecision = (info && info.holePrecision)? info.holePrecision : 3;
    var copperHeight = (info && info.copperHeight)? info.copperHeight : 1;

    var polyons = [];
    this.data.description().holes.forEach(function(id, hole){
        var geom = hole.outlineGeometry(holePrecision);
        polyons.push(new lib_geometry.Polygon(geom.points));
    });
    this.data.description().pads.forEach(function(id, pad){
        if(pad.getDrillSegmentedGeometry){
            var geom = pad.getDrillSegmentedGeometry(holePrecision);
            if (geom != null) {
                geom = geom.close().toOutlineGeometry(copperHeight * 2, 2).toTrace().close();
                polyons.push(new lib_geometry.Polygon(geom.points));
            }
        }
    });

    return lib_geometry.Union(polyons, []);
}


//////////////

FootprintInstanceInteractionModel.prototype._buildCollectionGeometry = function(collections, isLayered, trans, info, holes){
    var merged = new lib_geometry.TriangleMesh();
    if(info) info.holes = holes;

    for(var i = 0; i < collections.length; i++){
        collections[i].forEach(function(id, item){
            if(isLayered) var mesh = item.shape().mesh(info);
            else var mesh = item.mesh(info);
            if(mesh.isEmpty()) return;
            mesh = mesh.copy();
            mesh.translate(0, 0, trans)
            merged.mergeMesh(mesh);
        });
    }
    return merged;
}



FootprintInstanceInteractionModel.prototype._buildBoardGeometry = function(info, holes){
    var buffer = (info && info.boardBuffer)? info.boardBuffer : 1;
    var thickness = (info && info.boardThickness)? info.boardThickness : 1;
    var copperHeight = (info && info.copperHeight)? info.copperHeight : 1;

    var mesh = (new lib_geometry.TriangleMesh()).fromDrilledBoard(
        this.boundingBox().x - buffer,
        this.boundingBox().y - buffer,
        this.boundingBox().width + (buffer * 2),
        this.boundingBox().height + (buffer * 2),
        thickness,
        holes
    );
    if(!mesh.isEmpty())
        mesh.translate(0, 0, -thickness - copperHeight - 2);
    return mesh;
}

FootprintInstanceInteractionModel.prototype.addForkButton = function(inputElements, name) {
    inputElements.push(
    {
        label      : name,
        tooltip    : "Replaces this package with a new editable copy of this package.",
        type       : ui_extensions.InspectorInputType.BUTTON,
        cEvent     : new lib_core.GuiEvent(lib_core.GuiEvents.START_FORK_PUBLIC_PACKAGE)
    });
};

// INSPECTOR!
FootprintInstanceInteractionModel.prototype.getInspectorElements = function () {

    var inspectorElements = {};
    var distUnitMem = this.distanceUnit;
    var rotUnitMem = this.rotationUnit;

    inspectorElements.input_elements = [];

    var editCEvent = new lib_core.GuiEvent(lib_core.GuiEvents.ASSET_EDIT).element(this.data);
    var updateCEvent = new lib_core.GuiEvent(lib_core.GuiEvents.ASSET_UPDATE).element(this.data);
    var forkCEvent = new lib_core.GuiEvent(lib_core.GuiEvents.ASSET_FORK).element(this.data);


     // the inspector will show because technically the fooptrint instance is still selected (via the switcher)
    // so here we hide everything editable if the object is not selected (no handles)
    if(this.selected()) {

        inspectorElements.input_elements = inspectorElements.input_elements.concat([
            {
                label      : 'X',
                type       : ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
                datamember : this.inspectorX,
                unitmember : distUnitMem,
                datatype   : cio_config.types.float
            },
            {
                label      : 'Y',
                type       : ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
                datamember : this.inspectorY,
                unitmember : distUnitMem,
                datatype   : cio_config.types.float
            },
            {
                label      : 'Z',
                type       : ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
                datamember : this.inspectorZ,
                unitmember : distUnitMem,
                datatype   : cio_config.types.float
            },
            {
                label      : 'RotationX',
                type       : ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
                datamember : this.inspectorRotationX,
                unitmember : rotUnitMem,
                datatype   : cio_config.types.float
            },
            {
                label      : 'RotationY',
                type       : ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
                datamember : this.inspectorRotationY,
                unitmember : rotUnitMem,
                datatype   : cio_config.types.float
            },
            {
                label      : 'RotationZ',
                type       : ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
                datamember : this.inspectorRotationZ,
                unitmember : rotUnitMem,
                datatype   : cio_config.types.float
            },

        ]);
    }

    var ismodel = (this.packageIM.data.model3d() instanceof cio_datamodel.Model3DReference || this.packageIM.data.hasIPCPreview());

    inspectorElements.input_elements = inspectorElements.input_elements.concat([
        {
            label      : 'SizeX',
            type       : ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember : this.sizeX,
            unitmember : distUnitMem,
            datatype   : cio_config.types.float,
            read_only  : (!this.selected() || !this.placementEdit || ismodel)
        },
        {
            label      : 'SizeY',
            type       : ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember : this.sizeY,
            unitmember : distUnitMem,
            datatype   : cio_config.types.float,
            read_only  : (!this.selected() || !this.placementEdit || ismodel)
        },
        {
            label      : 'SizeZ',
            type       : ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember : this.sizeZ,
            unitmember : distUnitMem,
            datatype   : cio_config.types.float,
            read_only  : (!this.selected() || !this.placementEdit || ismodel)
        }
    ]);

    var makeBox = new lib_core.GuiEvent(lib_core.GuiEvents.MODEL_MAKE_BOX);
    var removeBox = new lib_core.GuiEvent(lib_core.GuiEvents.MODEL_REMOVE);

    if(!this.packageIM.masterModel.wizardMode() && this.placementEdit){
        //show replace with box when there is a custom 3d model
        if(ismodel) {
            inspectorElements.input_elements.push(
            {
                label      : 'Replace with Box',
                type       : ui_extensions.InspectorInputType.BUTTON,
                cEvent     : makeBox
            });
        } else {
            if (this.data.pads.size() > 0) {
                //show resize to copper if there is a box
                if(this.packageIM.data.model3d()) {
                    inspectorElements.input_elements.push(
                    {
                        label      : 'Resize to Copper',
                        type       : ui_extensions.InspectorInputType.BUTTON,
                        cEvent     : makeBox
                    });
                } else if(!this.packageIM.data.hasIPCPreview()) {//show add box if there is no 3d geometry and IPC preview is not there
                    inspectorElements.input_elements.push(
                    {
                        label      : 'Add Box',
                        type       : ui_extensions.InspectorInputType.BUTTON,
                        cEvent     : makeBox
                    });
                }
            }
        }

        //show remove 3d model if there is a 3d geometry and IPC preview is not there
        if(this.packageIM.data.model3d() && !this.packageIM.data.hasIPCPreview()) {
            inspectorElements.input_elements.push(
            {
                label      : 'Remove 3D Model',
                type       : ui_extensions.InspectorInputType.BUTTON,
                cEvent     : removeBox
            });
        }
    }

    if(this.selected() && this.packageIM.data.ipcParametricData()) {
        //Button to show IPC Params if exists
        inspectorElements.input_elements.push(
        {
            label      : 'View IPC Parameters',
            type       : ui_extensions.InspectorInputType.BUTTON,
            cEvent     : new lib_core.GuiEvent(lib_core.GuiEvents.VIEW_IPC_PARAMS_READ_ONLY),
            isToggleButton: true,
            isActive   : this.readOnlyIPCParamsVisible,
            isDisabled : this.disableViewIPCParamButton
        });
    }

    if(this.selected()) {
        // if a hub is provided, show fork and replace button (if asset is not owned by user.)
        // if hub is not provided, show "Copy Asset" button
        if(!this.packageIM.data.root.asset.hasUserWritePermissions()){
          if(this.config.targetHub){
            this.addForkButton(inspectorElements.input_elements, "Fork and Replace");
          } else {
            this.addForkButton(inspectorElements.input_elements, "Make New Copy");
          }
        }
    }

    ////// BUTTONS FOR EDITING AND FORKING FOOTPRINT!
    //      these belong in the switcher, not inspector
    // if(self.footprintOpen){
    //     inspectorElements.input_elements.push(
    //         {
    //             label      : 'Edit Footprint',
    //             type       : ui_extensions.InspectorInputType.BUTTON,
    //             cEvent     : editCEvent
    //         },
    //         {
    //             label      : 'Fork and Replace',
    //             type       : ui_extensions.InspectorInputType.BUTTON,
    //             cEvent     : forkCEvent
    //         }
    //     );
    // }

    // if(self.versionEdit){
    //     inspectorElements.input_elements.push(
    //         {
    //             label      : 'Loading',
    //             type       : ui_extensions.InspectorInputType.SPINNER,
    //             visible    : self.versionsNotLoaded
    //         },
    //         {
    //             label      : 'Version ',
    //             type       : ui_extensions.InspectorInputType.SELECTBOXEVENT,
    //             list       : self.versions,
    //             cEvent     : updateCEvent,
    //             init       : self.version(),
    //             visible    : self.versionsLoaded
    //         }
    //     );
    // }


    inspectorElements.help_elements = {
        'name': 'Package Inspector'
    };


    return inspectorElements;
};
